import { Box, CheckCircleIcon, Typography } from '@customink/pigment-react';

import satisfaction from '@/assets/satisfaction.svg';
import {
  PgmntColorPartnershipBackgroundBold,
  PgmntColorPartnershipBackgroundSubtle,
  PgmntRadiusCard,
  spacing16,
} from '@/utils/designTokens';

interface SatisfactionProps {
  withBg?: boolean;
  compact?: boolean;
}

export function Satisfaction({
  withBg = false,
  compact = false,
}: SatisfactionProps) {
  return (
    <Box
      display="flex"
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: compact ? '2px' : spacing16,
        ...(withBg && {
          background: `linear-gradient(${PgmntColorPartnershipBackgroundSubtle}, 
                ${PgmntColorPartnershipBackgroundSubtle}),
                linear-gradient(white, white)`,
          padding: spacing16,
          borderRadius: PgmntRadiusCard,
        }),
      }}
    >
      {!compact ? (
        <img
          alt="satisfaction"
          src={satisfaction}
          style={{
            height: '72px',
            width: '72px',
            transform: 'rotateZ(-13deg)',
          }}
        />
      ) : (
        <CheckCircleIcon sx={{ color: PgmntColorPartnershipBackgroundBold }} />
      )}
      <Box display="flex" style={{ flexDirection: 'column', gap: '4px' }}>
        <Typography sx={{ color: '#FA3C00' }} variant="heading5">
          100% Satisfaction Guaranteed
        </Typography>
        {!compact && (
          <Typography variant="uiTextSmall">
            We&apos;ll make it right or we&apos;ll make it&nbsp;right.
          </Typography>
        )}
      </Box>
    </Box>
  );
}
